import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiUploadCloud, FiX } from "react-icons/fi";
import { toast } from "react-toastify";

const CommentsForm = ({
  initialData = null,
  onSubmit,
  onCancel,
  requireImage = true,
}) => {
  const [form, setForm] = useState({
    name: "",
    comment: "",
    image: null,
    video: null,
  });

  const [imagePreview, setImagePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm({
        name: initialData.name || "",
        comment: initialData.comment || "",
        image: null,
        video: null,
      });
      setImagePreview(initialData.imageUrl || null);
      setVideoPreview(initialData.videoUrl || null);
    } else {
      setForm({ name: "", comment: "", image: null, video: null });
      setImagePreview(null);
      setVideoPreview(null);
    }
  }, [initialData]);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024)
        return toast.error("Rasm 5MB dan kichik bo‘lishi kerak");
      setForm((prev) => ({ ...prev, image: file }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleVideo = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 50 * 1024 * 1024)
        return toast.error("Video 50MB dan kichik bo‘lishi kerak");
      setForm((prev) => ({ ...prev, video: file }));
      setVideoPreview(URL.createObjectURL(file));
    }
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setForm((prev) => ({ ...prev, image: null }));
    setImagePreview(null);
  };

  const removeVideo = (e) => {
    e.stopPropagation();
    setForm((prev) => ({ ...prev, video: null }));
    setVideoPreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.comment.trim())
      return toast.error("Majburiy maydonlar to‘ldirilishi kerak");
    if (requireImage && !form.image && !imagePreview)
      return toast.error("Rasm majburiy");

    onSubmit({
      name: form.name,
      comment: form.comment,
      image: form.image,
      video: form.video,
    });
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="banner-form"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="form-grid">
        <div className="form-item">
          <label>O‘quvchi ismi *</label>
          <input
            name="name"
            value={form.name}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, name: e.target.value }))
            }
            required
          />
        </div>

        <div className="form-item">
          <label>Rasm {requireImage ? "*" : ""}</label>
          <div className="image-upload-box">
            {imagePreview ? (
              <div className="image-preview-wrapper">
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "cover",
                    borderRadius: 14,
                  }}
                />
                <motion.button
                  type="button"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  className="remove-image-btn"
                  onClick={removeImage}
                >
                  <FiX size={18} />
                </motion.button>
              </div>
            ) : (
              <motion.label
                htmlFor="photoInput"
                className="upload-area"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <FiUploadCloud size={44} color="#00c853" />
                <p>Rasm yuklash</p>
                <span>JPG, PNG • Maks 5MB</span>
              </motion.label>
            )}
            <input
              id="photoInput"
              type="file"
              accept="image/*"
              hidden
              onChange={handleImage}
            />
          </div>
        </div>

        <div className="form-item">
          <label>Video (ixtiyoriy)</label>
          <div className="image-upload-box">
            {videoPreview ? (
              <div className="image-preview-wrapper">
                <video
                  src={videoPreview}
                  controls
                  style={{ width: "100%", height: 200, borderRadius: 14 }}
                />
                <motion.button
                  type="button"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                  className="remove-image-btn"
                  onClick={removeVideo}
                >
                  <FiX size={18} />
                </motion.button>
              </div>
            ) : (
              <motion.label
                htmlFor="videoInput"
                className="upload-area"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <FiUploadCloud size={44} color="#00c853" />
                <p>Video yuklash</p>
                <span>MP4 • Maks 50MB</span>
              </motion.label>
            )}
            <input
              id="videoInput"
              type="file"
              accept="video/*"
              hidden
              onChange={handleVideo}
            />
          </div>
        </div>

        <div className="form-item full-width">
          <label>Izoh *</label>
          <textarea
            rows="5"
            value={form.comment}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, comment: e.target.value }))
            }
            placeholder="O‘quvchi fikri..."
            required
          />
        </div>

        <div className="form-buttons">
          <button type="submit" className="save">
            {initialData ? "Yangilash" : "Qo‘shish"}
          </button>
          <button type="button" className="cancel" onClick={onCancel}>
            Bekor qilish
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default CommentsForm;
